import { API_URL } from "config";
import Http from "util/https";
import { AmountAPISymbol, StoreResponseApi, StoreSearchApiParams, StoreStockList } from "../types/index";
import { convertSymbolAPItoClient, convertUTCToDateTimeMinutes, nullToBlank, nullToZero } from "../utils/common";
import { storeStockApiResponse } from "./apiConstants";

const splitSetStr = '+';

/**
 * 店舗用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns StoreStockList
 */
export default async function storeStockListApi(params: StoreSearchApiParams) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/select/shop`;
  const res = await http.post<StoreResponseApi>(url, params);

  // const res: {data: StoreResponseApi} = {data: storeStockApiResponse};
  // await new Promise((resolve) => {setTimeout(resolve, 1500)});

  const stockList: StoreStockList = {
    total: res.data.total,
    storeUpdated: convertUTCToDateTimeMinutes(res.data.shop_updated),
    storehouseUpdated: convertUTCToDateTimeMinutes(res.data.depot_updated),
    stocks: res.data.stocks.map((s, i) => {
      if (s.item_code.length === 6) {
        const notNullNear = nullToBlank(s.vendor_nearby_quantity, '-');
        const notNullCenter = nullToBlank(s.vendor_centor_quantity, '-');
        return {
          id: `${i + (params.offset ?? 0)}`,
          JANCd: s.jan_cd,
          productNumber: s.item_num,
          productName: s.item_name ?? '',
          brand: s.brand_name ?? '',
          productCd: s.item_code,
          size: s.size ?? '',
          classification: s.class_name,
          tyreStorehouse: s.depot_quantity,
          storeAmount: nullToZero(s.store_quantity),
          neighborAmount: Number.isNaN(Number(notNullNear)) ? convertSymbolAPItoClient(notNullNear as AmountAPISymbol) : Number(notNullNear),
          centerAmount: Number.isNaN(Number(notNullCenter)) ? convertSymbolAPItoClient(notNullCenter as AmountAPISymbol) : Number(notNullCenter),
          supplierName: s.vendor_name,
          arrivalDate: s.vendor_arrival_date,
          updateTime: convertUTCToDateTimeMinutes(s.vendor_updated_at),
          isDiscontinued: s.discontinued_flag,
          isStagnantStock: s.is_stagnant_stock
        }
      }
      return {
        id: `${i + (params.offset ?? 0)}`,
        JANCd: s.jan_cd,
        productNumber: s.item_num,
        productName: s.item_name ?? '',
        productSetCd: s.item_code,
        classification: "タイヤ・ホイール",
        stockSingleList: [{
          // タイヤ
          productCd: s.item_code.slice(0, 6),
          productName: s.item_name ? s.item_name.split(splitSetStr)[0] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[0] : '',
          size: s.size ? s.size.split(splitSetStr)[0] : '',
          quantity: 1
        }, {
          // ホイール
          productCd: s.item_code.slice(6, 12),
          productName: s.item_name ? s.item_name.split(splitSetStr)[1] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[1] : '',
          size: s.size ? s.size.split(splitSetStr)[1] : '',
          quantity: 1
        }],
        tyreStorehouse: s.depot_quantity,
        storeAmount: nullToZero(s.store_quantity),
        isDiscontinued: s.discontinued_flag,
        isStagnantStock: s.is_stagnant_stock
      }
    }),
  };

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res);
  // return res.data;
  return stockList;
}
